<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mold/up/down/record/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujubianhao')">
            <el-input v-model="yt.conditions.mouldNo" />
          </el-form-item>
          <el-form-item :label="$t('mujubianma')">
            <el-input v-model="yt.conditions.mouldCode" />
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shangmoshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.beginDate" :end.sync="yt.conditions.endDate"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
          </el-form-item>
        </el-form>
      </template>

      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w2')" type="primary" v-if="utils.checkPower('web_mold_management_up_down_record_create')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具入库单-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-button @click="yt.showEditDialog('bianji', scope.row, 'w2')" type="text" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: 'bianji' } }" v-if="utils.checkPower('web_mold_management_up_down_record_update')">
          {{ $t('bianji') }}
        </el-button>

        <el-button :loading="yt.editObj.loading" type="text" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: 'shangchuan' } }" @click="uploadRecord(scope.row.id)" v-if="utils.checkPower('web_mold_management_up_down_record_recordSync')">
          {{ $t('shangchuan') }}
        </el-button>

        <el-button @click="getLogData(scope.row.id)" type="text" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: 'rizhi' } }" v-if="utils.checkPower('web_mold_management_up_down_record_sync_log')">
          {{ $t('rizhi') }}
        </el-button>

        <el-button @click="yt.showEditDialog('baogongjilu', scope.row, '1200px')" type="text" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: 'baogongjilu' } }">
          {{ $t('baogongjilu') }}
        </el-button>
        <el-button type="text" class="font-color-danger"
          @click="yt.remove(scope.row,'/web/mold/up/down/record/delete')">{{$t('shanchu')}}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @closed="onClose()">
      <!-- 新增/编辑表单 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" :model="yt.editObj">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('muju')" required>
                <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId" :multiple="false"></yi_data_select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('shebei')" required>
                <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId" :multiple="false"></yi_data_select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('shangmoshijian')" required>
                <yi_time_input :time.sync="yt.editObj.upMoldTime" :type="'datetime'"></yi_time_input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('shangmocaozuoren')">
                <yi_data_select :type="'customer_user'" :ids.sync="yt.editObj.upMoldBy" :multiple="false"></yi_data_select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('xiamoshijian')">
                <yi_time_input :time.sync="yt.editObj.lowerMoldTime" :type="'datetime'"></yi_time_input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('xiamocaozuoren')">
                <yi_data_select :type="'customer_user'" :ids.sync="yt.editObj.lowerMoldBy" :multiple="false"></yi_data_select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('kaihemocishu')">
                <el-input v-model="yt.editObj.moldCount" style="width: 200px;" type="number" min="1" disabled>
                  <template slot="append">
                    <el-button type="text" @click="getMoldCount" style="color: #409EFF;">{{ $t('huoqumoci') }}</el-button>
                    <i class="el-icon-question" style="margin-left: 5px; color: #909399;"></i>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('shangchuanzhuangtai')">
                <el-tag :type="yt.editObj.uploadStatus === '1' ? 'success' : 'info'" size="small">
                  {{ yt.editObj.uploadStatus === '1' ? $t('yitongbu') : $t('weitongbu') }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveRecord" type="primary">{{ $t('baocun') }}</el-button>
        </template>
      </template>

      <!-- 日志弹窗 -->
      <template v-if="yt.editObj.action == 'rizhi'">
        <div class="dialog-scroller">
          <el-table :data="logData" style="width: 100%">
            <el-table-column prop="createTime" label="上传时间">
              <template #default="{ row }">
                {{ dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column prop="logContext" label="上传日志"> </el-table-column>
          </el-table>

          <div style="margin-top: 20px; text-align: center;">
            <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          </div>
        </div>
      </template>

      <!-- 报工记录弹窗 -->
      <template v-if="yt.editObj.action == 'baogongjilu'">
        <div class="dialog-scroller">
          <report :mouldId="yt.editObj.mouldId" :mouldNo="yt.editObj.mouldNo" :equipmentId="yt.editObj.equipmentId" :equipmentName="yt.editObj.equipment.name" :upMoldTime="yt.editObj.upMoldTime" :lowerMoldTime="yt.editObj.lowerMoldTime"></report>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import report from './report/index';
export default {
  components: {
    report
  },
  name: 'web_mold_up_down_record',
  data() {
    return {
      exportLoading: false,
      logData: [],
      workRecordData: [],
      columns: [
        {
          label: 'mujubianhao',
          prop: 'mouldNo'
        },
        {
          label: 'mujubianma',
          prop: 'mouldCode'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'shebeiSN',
          prop: 'equipmentSn'
        },
        {
          label: 'shangmoshijian',
          prop: 'upMoldTime',
          type: 'time'
        },
        {
          label: 'shangmocaozuoren',
          prop: 'upMoldByObject.nickname'
        },
        {
          label: 'xiamoshijian',
          prop: 'lowerMoldTime',
          type: 'time'
        },
        {
          label: 'xiamocaozuoren',
          prop: 'lowerMoldByObject.nickname'
        },
        {
          label: 'kaihemocishu',
          prop: 'moldCount'
        },
        {
          label: 'shangchuanzhuangtai',
          prop: 'uploadStatus',
          type: 'tag',
          width: 130,
          tags: {
            0: {
              color: '#419FFF',
              text: this.$t('weitongbu')
            },
            1: {
              color: '#419FFF',
              text: this.$t('yitongbu')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 保存记录
    saveRecord() {
      try {
        this.yt.editObj.loading = true;
        // 表单验证
        if (!this.yt.editObj.mouldId) {
          this.$message.error(this.$t('qingxuanzemuju'));
          return;
        }

        if (!this.yt.editObj.equipmentId) {
          this.$message.error(this.$t('qingxuanzeshebei'));
          return;
        }

        if (!this.yt.editObj.upMoldTime) {
          this.$message.error(this.$t('qingtianxieshangmoshijian'));
          return;
        }

        // 时间验证：下模时间不能早于上模时间
        if (this.yt.editObj.lowerMoldTime && this.yt.editObj.upMoldTime) {
          if (this.yt.editObj.lowerMoldTime < this.yt.editObj.upMoldTime) {
            this.$message.error(this.$t('xiamoshijianbunengzaoyushangmoshijian'));
            return;
          }
        }
        let url = this.yt.editObj.action == 'xinzeng' ? 'web/mold/up/down/record/create' : 'web/mold/up/down/record/update';

        this.http.post(url, this.yt.editObj).then(res => {
          this.yt.isShowEditDialog = false;
          this.$message.success(this.$t('success'));
          this.yt.get(1);
        });
      } finally {
        this.yt.editObj.loading = false;
      }
    },

    // 获取模次
    getMoldCount() {
      if (!this.yt.editObj.equipmentId || !this.yt.editObj.lowerMoldTime || !this.yt.editObj.upMoldTime) {
        this.$message.warning(this.$t('qingxianxuanzeshebeihemuju'));
        return;
      }
      this.http
        .get('/web/mold/up/down/record/getMouldCount', {
          params: {
            equipmentId: this.yt.editObj.equipmentId,
            startTime: this.yt.editObj.upMoldTime,
            endTime: this.yt.editObj.lowerMoldTime
          }
        })
        .then(res => {
          this.$set(this.yt.editObj, 'moldCount', res.data);
        });
    },

    // 上传记录
    uploadRecord(id) {
      try {
        this.yt.editObj.loading = true;
        this.http
          .get('/custom/gelanda/mould/sync/recordSync', {
            params: {
              id: id
            }
          })
          .then(res => {
            this.yt.editObj.loading = false;
            this.yt.get(1);
          });
      } finally {
      }
    },

    // 获取日志数据
    getLogData(id) {
      this.http
        .get('/web/mold/up/down/sync/log/page', {
          params: {
            recordId: id
          }
        })
        .then(res => {
          this.logData = res.data.rows;
          this.yt.showEditDialog('rizhi', null, 'w2');
        });
    },

    // 获取报工记录数据
    getWorkRecordData() {},

    // 导出Excel
    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/web/mold/up/down/record/page?page=1&limit=10000', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => {
            if (i.label != 'caozuo') {
              return this.$t(i.label);
            }
          });
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i], tableFirst);
            tableData.push(dataArr);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `上下模记录-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row, tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = row.mouldNo;
      dataArr[tableFirst.indexOf(this.$t('mujubianma'))] = row.mouldCode;
      dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = row.mould ? row.mould.name : '';
      dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = row.equipment ? row.equipment.name : '';
      dataArr[tableFirst.indexOf(this.$t('shebeiSN'))] = row.equipmentSn;
      dataArr[tableFirst.indexOf(this.$t('shangmoshijian'))] = row.upMoldTime ? this.dayjs(row.upMoldTime).format('YYYY-MM-DD HH:mm:ss') : '';
      dataArr[tableFirst.indexOf(this.$t('shangmocaozuoren'))] = row.upMoldByObject ? row.upMoldByObject.nickname : '';
      dataArr[tableFirst.indexOf(this.$t('xiamoshijian'))] = row.lowerMoldTime ? this.dayjs(row.lowerMoldTime).format('YYYY-MM-DD HH:mm:ss') : '';
      dataArr[tableFirst.indexOf(this.$t('xiamocaozuoren'))] = row.lowerMoldByObject ? row.lowerMoldByObject.nickname : '';
      dataArr[tableFirst.indexOf(this.$t('kaihemocishu'))] = row.moldCount;
      dataArr[tableFirst.indexOf(this.$t('shangchuanzhuangtai'))] = row.uploadStatus ? (row.uploadStatus === '0' ? '未上传' : '已上传') : '';
      return dataArr;
    },

    // 初始化编辑数据
    initEditData() {
      // 编辑时数据已经在 yt.editObj 中，这里可以做一些额外的处理
      // 比如格式化时间等
      if (this.yt.editObj.upMoldTime) {
        // 确保时间格式正确
        this.yt.editObj.upMoldTime = parseInt(this.yt.editObj.upMoldTime);
      }
      if (this.yt.editObj.lowerMoldTime) {
        this.yt.editObj.lowerMoldTime = parseInt(this.yt.editObj.lowerMoldTime);
      }
    },

    // 弹窗关闭时清理数据
    onClose() {
      this.logData = [];
      this.workRecordData = [];
    }
  },

  watch: {
    'yt.isShowEditDialog'(newVal) {
      if (newVal) {
        if (this.yt.editObj.action === 'baogongjilu') {
          this.getWorkRecordData();
        } else if (this.yt.editObj.action === 'bianji') {
          // 编辑时回显数据
          this.initEditData();
        }
      }
    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.upload-status-dialog,
.log-dialog,
.work-record-dialog {
  padding: 20px;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-row {
  margin-bottom: 10px;
}
</style>
